import React from "react"
import Layout from "../components/Layout"
import { Icon7, Icon8, Icon9 } from "../components/Icons"




export default function Contact({ location }) {
  return (
    <Layout location={location.pathname}>
      <div className="flex flex-col w-full gap-48 h-full max-w-5xl w-full mx-auto text-base  sm:text-lg  px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 ">
        <div className="flex flex-wrap mt-12  justify-center gap-16 text-base sm:text-lg">
          <a href="tel:+94766743755" className="max-w-xs w-full items-center flex flex-col gap-8">
            <Icon7 />
            <span className="flex-shrink-0">+94766743755</span>
          </a>
          <a href="mailto:sayhellokeepit@gmail.com" className="max-w-sm w-full items-center text-center flex flex-col gap-8">
            <Icon8 />

            <span className="flex-shrink-0">sayhellokeepit@gmail.com</span>
          </a>
          <div className="max-w-sm w-full items-center text-center flex flex-col gap-8">
            <Icon9 />

            <span className="flex-shrink-0">Richmond Hill, Galle,Sri Lanka</span>
          </div>
        </div>
      </div>
    </Layout>
  )
}
